import React from 'react'
import { ModalProps } from '../../interfaces/modal'
import { Input } from '../ui/inputs/Input';
import { useSocialStore } from '../../stores/social';
import { getEventsSageExport } from '../../api/events';
import { showToastError } from '../../services/toast';
import { getFileNameFromResponse } from '../../services/function';
import { ModalButton, ModalShell } from '../ui/modals/ModalShell';

const ExportSage: React.FC<ModalProps> = ({ closeModal }) => {

    const { formData, setFormData } = useSocialStore();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const handleSubmit = () => {
        getEventsSageExport(formData.dateStart, formData.dateEnd)
          .then((res) => {
            const url = window.URL.createObjectURL(
                new Blob([res.data], { type: "application/txt" })
              );
              
              // Extraire le nom de fichier depuis Content-Disposition
              let filename = `export_sage_.txt`;
              const fileNameFromResponse = getFileNameFromResponse(res);
              if (fileNameFromResponse && !fileNameFromResponse.includes('template_')) {
                filename = fileNameFromResponse;
              }
              
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              closeModal();
          })
          .catch((err) => {
            showToastError(err.response.data.message);
          });
    }
    
  return (
    <ModalShell
      title="Export Sage"
      subtitle="Séléctionner la date de début et de fin pour l'export Sage."
      size="sm"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton variant="primary" type="submit" onClick={handleSubmit}>
            Exporter
          </ModalButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-3 font-Nunito sm:grid-cols-2">
        <Input
          label="Date de début"
          name="dateStart"
          required
          type="date"
          value={formData.dateStart || ""}
          onChange={handleChange}
          clasName="w-full"
        />
        <Input
          label="Date de fin"
          name="dateEnd"
          required
          type="date"
          value={formData.dateEnd || ""}
          onChange={handleChange}
          clasName="w-full"
        />
      </div>
    </ModalShell>
  )
}

export default ExportSage